import 'public/style.scss'
import 'public/main'
import 'public/js/notification'
import TwCitySelector from 'tw-city-selector'
import Rails from "@rails/ujs"
Rails.start();

window.jQuery = $;
window.$ = $;
window.TwCitySelector = TwCitySelector;
